"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function StreamFilters(_ref) {
  var indexFilter = _ref.indexFilter,
      setIndexFilter = _ref.setIndexFilter,
      isSimple = _ref.isSimple;
  var quadrants = (0, _reactRedux.useSelector)(function (state) {
    return state.quadrants;
  });
  var addressableAudience = quadrants.addressableAudience,
      personasInput = quadrants.personasInput,
      personasRefined = quadrants.personasRefined,
      sumOfValues = quadrants.sumOfValues;
  var debouncedInput = (0, _debounce["default"])(setIndexFilter, 650);

  function handleInputChange(e, _ref2) {
    var value = _ref2.value;
    debouncedInput(parseInt(value, 10));
  }

  var IndexInput = /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
    type: "number",
    className: "message-streams--input-filter",
    placeholder: 0,
    disabled: isSimple,
    onChange: handleInputChange,
    style: {
      width: '100%'
    },
    maxLength: 3,
    defaultValue: indexFilter,
    onInput: function onInput(event) {
      // TODO: Add handling for if number is greater than 100?
      // let value = parseFloat(event.target.value);
      var length = event.target.value.length;
      var maxLength = event.target.value.includes('.') ? event.target.maxLength + 1 : event.target.maxLength;

      if (length > maxLength) {
        event.target.value = event.target.value.slice(0, maxLength);
      }
    }
  });

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    style: {
      paddingBottom: '1em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    tablet: 6,
    computer: 6
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "1. ", isSimple ? 'Selected Audience' : 'Refine Audience')), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    tablet: 6,
    computer: 6
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    columns: isSimple ? 1 : 2,
    style: {
      paddingTop: 0,
      paddingBottom: '1em'
    }
  }, isSimple ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    tablet: 8,
    computer: 6
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "message-streams--audience-container"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Audience Size:"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "message-streams--audience"
  }, /*#__PURE__*/_react["default"].createElement("span", null, addressableAudience ? addressableAudience.toLocaleString() : '0', ' ', "(", personasInput || '0', " personas)")))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    tablet: 4,
    computer: 2
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Index"), IndexInput), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    tablet: 8,
    computer: 10
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "message-streams--audience-container"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Audience Size:"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "message-streams--audience"
  }, addressableAudience && addressableAudience.toLocaleString(), ' ', "(filtered to ", personasRefined, " of ", personasInput, " personas,", ' ', sumOfValues ? sumOfValues.toFixed(1) : '~', "% of the profile)"))))));
}

var _default = StreamFilters;
exports["default"] = _default;